<template>
  <div>
    <Forms
      ref="frmSinisterWorkshopReturn"
      :title="'RETORNO DA OFICINA'"
      :showHelp="true"
      :showClearButton="false"
      :showSearchButton="false"
    >
      <Alerts ref="alert" />
      <div class="form-group row" v-show="STG_FRUSTRATED || STG_CANCELED">
        <div class="col-md-12 border border-danger rounded bg-danger text-center">
          <span class="text-white" v-if="STG_FRUSTRATED">FRUSTRADO</span>
          <span class="text-white" v-else>CANCELADO</span>
        </div>
      </div>
      <SinisterHeader ref="SinisterHeader" />
      <div class="form-group row">
        <div class="col-md-12">
          <hr />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 intermediate-bar">
          <i class="fa fa-dollar"></i>&nbsp; VALORES
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 text-center">
          <div class="form-group row">
            <div class="col-md-3 text-left">
              <label for="txtBodywork">Funilaria:</label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-dollar"></i>
                </span>
                <money
                  name="txtBodywork"
                  class="form-control form-control-10 text-right"
                  :placeholder="'0,00'"
                  prefix="R$ "
                  v-model="form.valueBodywork.value"
                  v-bind="moneyFormat"
                  :size="form.valueBodywork.maxlength"
                  :required="form.valueBodywork.required"
                  :state="form.valueBodywork.state"
                  :disabled="this.isCompleted"
                ></money>
              </div>
            </div>
            <div class="col-md-3 text-left">
              <label for="txtPainting">Pintura:</label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-dollar"></i>
                </span>
                <money
                  name="txtPainting"
                  class="form-control form-control-10 text-right"
                  :placeholder="'0,00'"
                  prefix="R$ "
                  v-model="form.valuePainting.value"
                  v-bind="moneyFormat"
                  :size="form.valuePainting.maxlength"
                  :required="form.valuePainting.required"
                  :state="form.valuePainting.state"
                  :disabled="this.isCompleted"
                ></money>
              </div>
            </div>
            <div class="col-md-3 text-left">
              <label for="txtTapestry">Tapeçaria/Vidraçaria:</label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-dollar"></i>
                </span>
                <money
                  name="txtPainting"
                  class="form-control form-control-10 text-right"
                  :placeholder="'0,00'"
                  prefix="R$ "
                  v-model="form.valueTapestry.value"
                  v-bind="moneyFormat"
                  :size="form.valueTapestry.maxlength"
                  :required="form.valueTapestry.required"
                  :state="form.valueTapestry.state"
                  :disabled="this.isCompleted"
                ></money>
              </div>
            </div>
            <div class="col-md-3 text-left">
              <label for="txtElectrical">Elétrica:</label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-dollar"></i>
                </span>
                <money
                  name="txtElectrical"
                  class="form-control form-control-10 text-right"
                  :placeholder="'0,00'"
                  prefix="R$ "
                  v-model="form.valueElectrical.value"
                  v-bind="moneyFormat"
                  :size="form.valueElectrical.maxlength"
                  :required="form.valueElectrical.required"
                  :state="form.valueElectrical.state"
                  :disabled="this.isCompleted"
                ></money>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-3 text-left">
              <label for="txtMechanical">Mecânica:</label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-dollar"></i>
                </span>
                <money
                  name="txtMechanical"
                  class="form-control form-control-10 text-right"
                  :placeholder="'0,00'"
                  prefix="R$ "
                  v-model="form.valueMechanical.value"
                  v-bind="moneyFormat"
                  :size="form.valueMechanical.maxlength"
                  :required="form.valueMechanical.required"
                  :state="form.valueMechanical.state"
                  :disabled="this.isCompleted"
                ></money>
              </div>
            </div>
            <div class="col-md-3 text-left">
              <label for="txtThird">Terceiros:</label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-dollar"></i>
                </span>
                <money
                  name="txtThird"
                  class="form-control form-control-10 text-right"
                  :placeholder="'0,00'"
                  prefix="R$ "
                  v-model="form.valueThird.value"
                  v-bind="moneyFormat"
                  :size="form.valueThird.maxlength"
                  :required="form.valueThird.required"
                  :state="form.valueThird.state"
                  :disabled="this.isCompleted"
                ></money>
              </div>
            </div>
            <div class="col-md-3 text-left">
              <label for="txtBudgeted">
                <strong>Total Orçado:</strong>
              </label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-dollar"></i>
                </span>
                <money
                  type="text"
                  name="txtBudgeted"
                  class="form-control form-control-10 text-right"
                  :placeholder="'0,00'"
                  prefix="R$ "
                  style="font-weight:bold;font-size:15px;"
                  :value="totalBudgeted"
                  v-bind="moneyFormat"
                  :size="form.valueTotalBudgeted.maxlength"
                  :required="form.valueTotalBudgeted.required"
                  :state="form.valueTotalBudgeted.state"
                  :disabled="this.isCompleted"
                ></money>
              </div>
            </div>
            <div class="col-md-3 text-left">
              <label for="cbxIsFullIndenization">Indenização integral?</label>
              <div class="input-group">
                <b-form-select
                  v-model="form.isFullIndenization.value"
                  :state="form.isFullIndenization.state"
                  class="mb-3"
                  name="cbxIsFullIndenization"
                  :disabled="this.isCompleted"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="form-group row" pt-4>
            <div class="col-md-12">
              <hr />
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 intermediate-bar">
          <i class="fa fa-car"></i>
          &nbsp; {{$lang.Sinister.Details.DataCar}}
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxAutoType">
            <small v-show="form.autoTypeID.required" class="text-danger">*</small>
            {{$lang.AutoModel.Autotype}}:
          </label>
          <div class="input-group">
            <b-form-select
              v-model="form.autoTypeID.value"
              :options="form.autoTypeID.options"
              :state="form.autoTypeID.state"
              class="mb-3"
              name="cbxAutoType"
              :disabled="this.isCompleted"
              @change="onChangeAutoType"
            >
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxBrand">
            <small v-show="form.brandID.required" class="text-danger">*</small>
            {{$lang.AutoModel.LabelBrand}}:
          </label>
          <div class="input-group">
            <b-form-select
              v-model="form.brandID.value"
              :options="form.brandID.options"
              :state="form.brandID.state"
              class="mb-3"
              name="cbxBrand"
              :disabled="this.isCompleted"
              @change="onChangeBrand"
            >
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <optgroup :label="$lang.Common.PlaceholderOptGroupDefault">
                  <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
                  <option :value="null">{{$lang.Common.PlaceholderAddSelect}}</option>
                </optgroup>
                <optgroup :label="$lang.Common.PlaceholderOptGroupOptions"></optgroup>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxAutoModel">
            <small v-show="form.autoModelID.required" class="text-danger">*</small>
            {{$lang.Sinister.Details.AutoModel}}:
          </label>
          <div class="input-group">
            <b-form-select
              v-model="form.autoModelID.value"
              :options="form.autoModelID.options"
              :state="form.autoModelID.state"
              class="mb-3"
              name="cbxBrand"
              :disabled="this.isCompleted"
            >
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <optgroup :label="$lang.Common.PlaceholderOptGroupDefault">
                  <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
                  <option :value="null">{{$lang.Common.PlaceholderAddSelect}}</option>
                </optgroup>
                <optgroup :label="$lang.Common.PlaceholderOptGroupOptions"></optgroup>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtYear">
            <small v-show="form.year.required" class="text-danger">*</small>
            {{$lang.Sinister.Details.Year}}:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              name="txtYear"
              :placeholder="'2018-2018'"
              v-model="form.year.value"
              :size="form.year.maxlength"
              :required="form.year.required"
              :state="form.year.state"
              v-mask="['####-####']"
              :disabled="this.isCompleted"
            />
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtColor">
            <small v-show="form.color.required" class="text-danger">*</small>
            {{$lang.Sinister.Details.Color}}:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              name="txtColor"
              :placeholder="'Branco'"
              v-model="form.color.value"
              :size="form.color.maxlength"
              :required="form.color.required"
              :state="form.color.state"
              :disabled="this.isCompleted"
            />
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtBudgetNumber">
            <small v-show="form.plate.required" class="text-danger">*</small>
            {{$lang.Sinister.Details.Board}}:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              name="txtBudgetNumber"
              :placeholder="'BRA-12J4'"
              v-model="form.plate.value"
              :size="form.plate.maxlength"
              :required="form.plate.required"
              :state="form.plate.state"
              :disabled="this.isCompleted"
            />
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtChassis">
            <small v-show="form.chassis.required" class="text-danger">*</small>
            {{$lang.Sinister.Details.Chassis}}:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              name="txtChassis"
              :placeholder="'XXXXXXXXXXXXXXXXX'"
              v-model="form.chassis.value"
              v-mask="['XXXXXXXXXXXXXXXXX']"
              :size="form.chassis.maxlength"
              :required="form.chassis.required"
              :state="form.chassis.state"
              :disabled="this.isCompleted"
            />
          </div>
        </div>
      </div>
      <br />

      <div class="form-group row">
        <div class="col-md-12 intermediate-bar">
          <i class="fa fa-wrench"></i>
          &nbsp; {{$lang.Sinister.WorkshopReturn.MechanicalDamage}}
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3">
          <div>
            <b-form-checkbox
              class="text-center"
              name="hasFrontSuspensionDamage"
              v-model="form.hasFrontSuspensionDamage.value"
              :disabled="this.isCompleted"
            >
              {{$lang.Sinister.WorkshopReturn.FrontSuspension}}
            </b-form-checkbox>
          </div>
        </div>
        <div class="col-md-3">
          <div>
            <b-form-checkbox
              class="text-center"
              name="hasRearSuspensionDamage"
              v-model="form.hasRearSuspensionDamage.value"
              :disabled="this.isCompleted"
            >
              {{$lang.Sinister.WorkshopReturn.RearSuspension}}
            </b-form-checkbox>
          </div>
        </div>
        <div class="col-md-3">
          <div>
            <b-form-checkbox
              class="text-center"
              name="hasEngineDamage"
              v-model="form.hasEngineDamage.value"
              :disabled="this.isCompleted"
            >
              {{$lang.Sinister.WorkshopReturn.Motor}}
            </b-form-checkbox>
          </div>
        </div>
        <div class="col-md-3">
          <div>
            <b-form-checkbox
              class="text-center"
              name="hasCoolingSystemsDamage"
              v-model="form.hasCoolingSystemsDamage.value"
              :disabled="this.isCompleted"
            >
              {{$lang.Sinister.WorkshopReturn.CoolingSystems}}
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <br />
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtAdditionalInformation">Informações adicionais</label>
          <b-form-textarea
            name="txtAdditionalInformation"
            v-model="form.mechanicalDamageInformation.value"
            :placeholder="$lang.Sinister.Details.PlaceholderSeem"
            :rows="3"
            :size="form.mechanicalDamageInformation.maxlength"
            :noResize="true"
            :disabled="this.isCompleted"
          />
        </div>
      </div>

      <br />
      <div class="form-group row">
        <div class="col-md-12 intermediate-bar">
          <i class="fa fa-wrench"></i>
          &nbsp; {{$lang.Sinister.WorkshopReturn.WorkshopConfirmationData}}
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-3">
          <label for="txtWorkshopReturnCNPJ">
            <small v-show="form.cnpj.required" class="text-danger">*</small>
            {{$lang.Sinister.WorkshopReturn.CNPJ}}:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              name="txtWorkshopReturnCNPJ"
              :placeholder="''"
              v-model="form.cnpj.value"
              :size="form.cnpj.maxlength"
              :required="form.cnpj.required"
              :state="form.cnpj.state"
              :disabled="this.isCompleted"
            />
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtWorkshopReturnContactName">
            <small v-show="form.contactName.required" class="text-danger">*</small>
            {{$lang.Sinister.WorkshopReturn.ContactName}}:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              name="txtWorkshopReturnContactName"
              :placeholder="''"
              v-model="form.contactName.value"
              :size="form.contactName.maxlength"
              :required="form.contactName.required"
              :state="form.contactName.state"
              :disabled="this.isCompleted"
            />
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtWorkshopReturnTelephone">
            <small v-show="form.telephone.required" class="text-danger">*</small>
            {{$lang.Sinister.WorkshopReturn.Telephone}}:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              name="txtWorkshopReturnTelephone"
              :placeholder="''"
              v-model="form.telephone.value"
              :size="form.telephone.maxlength"
              :required="form.telephone.required"
              :state="form.telephone.state"
              :disabled="this.isCompleted"
            />
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtWorkshopReturnEmail">
            <small v-show="form.workshopEmail.required" class="text-danger">*</small>
            {{$lang.Sinister.WorkshopReturn.Email}}:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              name="txtWorkshopReturnEmail"
              :placeholder="''"
              v-model="form.workshopEmail.value"
              :size="form.workshopEmail.maxlength"
              :required="form.workshopEmail.required"
              :state="form.workshopEmail.state"
              :disabled="this.isCompleted"
            />
          </div>
        </div>
      </div>

      <div class="form-group row pb-3">
        <div class="col-md-12">
          <label for="txtWorkshopReturnObservation">
            <small v-show="form.observation.required" class="text-danger">*</small>
            {{$lang.Sinister.WorkshopReturn.Observation}}:
          </label>
          <div class="input-group">
            <b-form-textarea
              type="text"
              name="txtWorkshopReturnObservation"
              :placeholder="''"
              v-model="form.observation.value"
              :size="form.observation.maxlength"
              :required="form.observation.required"
              :rows="3"
              :state="form.observation.state"
              :noResize="true"
              :disabled="this.isCompleted"
            />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-10 intermediate-bar" style="font-size:16px;">
          <i class="fa fa-image"></i>&nbsp; Imagens
        </div>
        <div @click="addFiles" class="col-md-2 intermediate-bar" style="font-size:14px; text-align: center; padding-top: 7px">
            <span style="cursor: pointer;"><i class="fa fa-cloud-upload"></i>&nbsp; Anexar </span>
            <input id="inputImagesUpload" type="file" ref="files" multiple style="display: none;" v-on:change="onUploadImage()" >
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12 text-center">
          <b-container fluid class="p-4 bg-white">
            <b-row>
              <b-col v-for="image in images" :key="image.id" sm="6" md="4" lg="4" xl="3">
                <b-img
                  v-if="image.contentType === 'image/png' || image.contentType === 'image/jpeg' || image.contentType === 'image/jpg' || image.contentType === 'image/gif'"
                  :title="image.id"
                  thumbnail
                  fluid
                  :src="getPath(image.filePath, image.fileName)"
                  alt="Thumbnail"
                  style="background-size: cover; display:inline-block; width: auto; height: auto; max-height: 220px;min-height: 220px;"
                />
                <div v-else class="formater-img img-thumbnail img-fluid" style="min-width: 100px; min-height: 220px;">
                  <div style="background-color: #fff; height: 220px; vertical-align: 20%;">
                    <a :href="getPath(image.filePath, image.fileName)" target="_black"  v-b-tooltip.hover :title="'Clique para abrir o arquivo'">
                      <i class="fa fa-file-text-o" style="font-size: 120px; padding-top: 12%;" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
                <figcaption
                  class="figure-caption text-center pb-2"
                  style="font-size:13px;color: #808080;"
                >{{ image.fileName }}</figcaption>
                <b-button pill size="sm" variant="danger" @click="onDeleteImage(image.id)" class="mb-4">
                <i class="fa fa-times-circle" aria-hidden="true"></i>&nbsp;
                {{ $lang.Common.Buttons.Delete }}&nbsp;&nbsp;
              </b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <br />
      <div class="form-group row">
        <div class="col-md-12 text-center pl-3">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-show="images && images.length > 0"
            v-on:click="downloadImages"
          >
            <i class="fa fa-download"></i>&nbsp; Baixar imagens
          </button>&nbsp;
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-modal.modalxl
            v-show="images && images.length > 0"
          >
            <i class="fa fa-image"></i>&nbsp; Visualizar imagens
          </button>&nbsp;
        </div>
      </div>
      <br />
      <div class="form-group row">
        <div class="col-md-10 intermediate-bar" style="font-size:16px;">
          <i class="fa fa-wrench"></i>&nbsp; Orçamentos
        </div>
        <div @click="addFilesBudgets" class="col-md-2 intermediate-bar" style="font-size:14px; text-align: center; padding-top: 7px">
            <input id="inputImages" type="file" ref="budgets" multiple style="display: none;" v-on:change="onUploadBudget()" >
            <span style="cursor: pointer;"><i class="fa fa-cloud-upload"></i>&nbsp; Anexar </span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12 text-center">
          <b-container fluid class="p-4 bg-white">
            <b-row>
              <b-col v-for="budget in budgets" :key="budget.id" sm="6" md="4" lg="4" xl="3">
                <b-img
                  v-if="budget.contentType === 'image/png' || budget.contentType === 'image/jpeg' || budget.contentType === 'image/jpg' || budget.contentType === 'image/gif'"
                  :title="budget.id"
                  thumbnail
                  fluid
                  :src="getPathBudget(budget.filePath, budget.fileName)"
                  alt="Thumbnail"
                  style="background-size: cover; display:inline-block; width: auto; height: auto; max-height: 220px;min-height: 220px;"
                />
                <div v-else class="formater-img img-thumbnail img-fluid" style="min-width: 100px; min-height: 220px;">
                  <div style="background-color: #fff; height: 220px; vertical-align: 20%;">
                    <a :href="getPathBudget(budget.filePath, budget.fileName)" target="_black"  v-b-tooltip.hover :title="'Clique para abrir o arquivo'">
                      <i class="fa fa-file-text-o" style="font-size: 120px; padding-top: 12%;" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
                <figcaption
                  class="figure-caption text-center pb-2"
                  style="font-size:13px;color: #808080;"
                >{{ budget.fileName }}</figcaption>
                <b-button pill size="sm" variant="danger" @click="onDeleteBudget(budget.id)" class="mb-4">
                  <i class="fa fa-times-circle" aria-hidden="true"></i>&nbsp;
                  {{ $lang.Common.Buttons.Delete }}&nbsp;&nbsp;
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <br />
      <div class="form-group row">
        <div class="col-md-12 text-center pl-3">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-show="budgets && budgets.length > 0"
            v-on:click="downloadBudgets"
          >
            <i class="fa fa-download"></i>&nbsp; Baixar orçamentos
          </button>&nbsp;
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-modal.modallg
            v-show="budgets && budgets.length > 0"
          >
            <i class="fa fa-image"></i>&nbsp; Visualizar Orçamentos
          </button>&nbsp;
        </div>
      </div>

      <div></div>
      <br />
      <div class="form-group row pb-3" v-if="hasRole(this.roles.RW_REG_TABWORKSHOP)" v-show="!this.isCompleted">
        <div class="col-md-12 text-left force-border-bottom pl-3">
          <button v-if="hasRole(this.roles.RW_REG_TABWORKSHOP)"
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="onSave"
            :disabled="this.isCompleted"
          >
            <i class="fa fa-check-circle"></i>
            {{$lang.Common.Buttons.Save}}
          </button>&nbsp;
          <button v-if="hasRole(this.roles.RW_REG_TABWORKSHOP)"
            type="button"
            class="btn btn-default btn-sm text-secundary"
            v-on:click="onClear"
            :disabled="this.isCompleted"
          >
            <i class="fa fa-minus-circle"></i>
            {{$lang.Common.Buttons.Clear}}
          </button>&nbsp;
        </div>
      </div>
    </Forms>
    <b-modal id="modalxl" size="xl" centered ok-only title="Imagens do processo">
      <b-carousel
        id="carousel1"
        style="text-shadow: 1px 1px 2px #333;"
        controls
        indicators
        background="#ababab"
        v-model="slide"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide
          v-for="image in images"
          :key="image.id"
          :img-src="`${image.filePath}/${image.fileName}`"
        >
          <img
            slot="img"
            class="d-block img-fluid w-100"
            :src="getPath(image.filePath, image.fileName)"
            alt="image slot"
          />
        </b-carousel-slide>
      </b-carousel>
    </b-modal>

    <b-modal id="modallg" size="xl" centered ok-only title="Imagens do processo">
      <b-carousel
        id="carousel2"
        style="text-shadow: 1px 1px 2px #333;"
        controls
        indicators
        background="#ababab"
        v-model="slide2"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide
          v-for="budget in budgets"
          :key="budget.id"
          :img-src="`${budget.filePath}/${budget.fileName}`"
        >
          <img
            slot="img"
            class="d-block img-fluid w-100"
            :src="getPathBudget(budget.filePath, budget.fileName)"
            alt="budget slot"
          />
        </b-carousel-slide>
      </b-carousel>
    </b-modal>
  </div>
</template>

<script>
import SinisterWorkshopReturn from './sinisterworkshopreturn.js'
export default SinisterWorkshopReturn
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/auto/workshopreturn/SinisterWorkshopReturn.vue